import { rem } from '../../../utils/rem';
export var MuiListItemIcon = {
    styleOverrides: {
        root: {
            color: 'inherit',
            minWidth: rem(32),
            '& > .MuiCheckbox-root ': {
                margin: 0,
            },
        },
    },
};
